import { render, staticRenderFns } from "./MintalMesPrdPelletizingIngredientPlanEdit.vue?vue&type=template&id=3b2a1480&"
import script from "./MintalMesPrdPelletizingIngredientPlanEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdPelletizingIngredientPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports